<template>
  <div id="app">


    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>


<!--    <div style="font-size: 24px;padding: 20px">-->
<!--      正在研发中，敬请期待...-->

<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  /*.header{*/
  /*  background-color: #fff;*/
  /*  position: -webkit-sticky;*/
  /*  position: sticky;*/
  /*  top: 0px;*/
  /*  z-index: 100000;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue